export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          关于快看影视
        </h2>
        <div className="mt-8 text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
          <p>
            快看影视成立于2020年，是国内领先的免费电视剧在线观看平台。我们致力于为广大追剧爱好者提供
            高清流畅的观影体验，片库覆盖古装、悬疑、都市、韩剧、美剧、谍战等多品类内容，
            累计服务超过千万追剧用户。
          </p>
          <p>
            平台采用智能CDN加速与自适应码率技术，确保不同网络环境下都能获得流畅播放体验。
            每日同步更新最新电视剧资源，热门在播剧集第一时间上线，让追剧党不再焦急等待。
            我们持续优化产品体验，坚持免费、高清、秒播三大核心承诺。
          </p>
          <p>
            快看影视，好剧一网打尽，陪你度过每一个追剧时光。
          </p>
        </div>
      </div>
    </section>
  );
}